module.exports = __webpack_public_path__ + "5858f95fe7209f3cb4457ea2d57642a4.MP3";